import { ApiClient } from "./apiClient";

const tokenRequestURL = "/token/"
const tokenRefreshURL = "/token/refresh/"
const profileRequestURL = "/user/profile/"
const isAdminRequestURL = "/is_admin/"
const avatarUploadURL = "/user/profile/avatar/";

export const tokenRefresh = async (refreshToken) => {
    if (refreshToken["refresh"] === null){
        return "null"
    }else{
        return ApiClient.public().post(tokenRefreshURL, refreshToken)
    }
}


export const tokenRequest = async (loginForm) => {
    return ApiClient.public().post(tokenRequestURL, loginForm)
}

export const profileRequest = async (store) => {
    return ApiClient.private(store).get(profileRequestURL)
}
export const isAdminRequest = async (store) => {
    return ApiClient.private(store).get(isAdminRequestURL)
}
export const profileUpdateRequest = async (store, profile) => {
    return ApiClient.private(store).put(`${profileRequestURL}${profile.user.id}/`, profile)
}

export const avatarUploadRequest = async (store, file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    
    return ApiClient.private(store).post(avatarUploadURL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
